import TextField, { TextFieldProps } from '@mui/material/TextField';

export interface FormTextFieldProps extends Omit<TextFieldProps, 'variant'> {
  label: string;
  variant?: 'outlined' | 'filled' | 'standard';
}

export function FormTextField({
  label,
  fullWidth = true,
  variant = 'outlined',
  ...props
}: FormTextFieldProps) {
  return (
    <TextField
      label={label}
      fullWidth={fullWidth}
      variant={variant}
      {...props}
    />
  );
}
